import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-133" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto w-full max-w-4xl px-5 text-center md:px-8" data-id="element-134" data-mp="1o3dj01a9xtlv">
        <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-xl bg-blue-50 ring-1 ring-blue-100" data-id="element-135" data-mp="2223kru81ghgk">
          <ShieldCheckIcon className="h-8 w-8 text-blue-600" aria-hidden="true" data-id="element-136" data-mp="1x54nx3wzpweo" />
        </span>

        <h2 className="mt-7 text-3xl font-extrabold leading-tight tracking-tight text-gray-900 md:text-5xl" data-id="element-137" data-mp="19f0m923d46qb">
          Garantía de 7 días
        </h2>

        <p className="mt-6 text-lg text-gray-900 md:text-xl" data-id="element-138" data-mp="1j5295qjzbj3n">
          Prueba el Atlas Visual de Instrumentación Quirúrgica durante 7 días.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-gray-600" data-id="element-139" data-mp="1ebr1jn7ceyao">
          Si el material no es lo que esperabas, puedes solicitar el reembolso del 100% dentro del
          período de garantía.
        </p>
        <p className="mt-4 font-semibold text-gray-900" data-id="element-140" data-mp="ln29edo9m3b2">Sin complicaciones.</p>
      </div>
    </section>;
}